// extracted by mini-css-extract-plugin
module.exports = {"overlayIcon":"_6127111","exclusiveOverlay":"_a71c12a","icnSquare":"_2401d8e","icnHeroSquare":"_38e3132","icnWide":"_d997340"};